import type {
  QueryClient,
} from '@tanstack/react-query';


export async function invalidateStacOrganizationQueries(
  queryClient: QueryClient,
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({
      queryKey: [
        'stac-organization-editor',
      ],
    }),

    queryClient.invalidateQueries({
      queryKey: [
        'stac-team-reporting-scope',
      ],
    }),

    queryClient.invalidateQueries({
      queryKey: [
        'stac-team-reporting-day',
      ],
    }),
  ]);
}


export async function invalidateStacTimeQueries(
  queryClient: QueryClient,
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({
      queryKey: [
        'stac-day',
      ],
    }),

    queryClient.invalidateQueries({
      queryKey: [
        'stac-dedication',
      ],
    }),

    queryClient.invalidateQueries({
      queryKey: [
        'stac-team-reporting-day',
      ],
    }),
  ]);
}